module.exports = __webpack_public_path__ + "img/no_team_selected.083e523d.svg";